import {PageType} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceConfig";
import {configPageNavigation} from "~/workspaceConfig/configPageNavigation";
import {setWorkspaceConfigFromUiConfig} from "~/workspaceConfig/configRuntime";
import {createFileRoute, redirect} from "@tanstack/react-router";
import {getAccessibleWorkspacesWithCaching, getEnabledWorkspaceUiConfigWithCaching} from "~/utilities/queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/account-settings")({
    beforeLoad: async ({context}) => {
        const accessibleWorkspacesResult = await getAccessibleWorkspacesWithCaching({
            accessToken: context.authenticationStatus.accessToken,
            intellsysBaseUrl: context.intellsysBaseUrl,
            queryClient: context.queryClient,
        });

        if (accessibleWorkspacesResult.success !== true) {
            throw accessibleWorkspacesResult.error;
        }

        const firstWorkspace = accessibleWorkspacesResult.data[0];
        if (firstWorkspace === undefined) {
            throw redirect({
                to: "/u/select-workspace",
            });
        }

        const configResult = await getEnabledWorkspaceUiConfigWithCaching({
            workspaceId: firstWorkspace.id,
            accessToken: context.authenticationStatus.accessToken,
            intellsysBaseUrl: context.intellsysBaseUrl,
            queryClient: context.queryClient,
        });
        if (configResult.success !== true) {
            throw configResult.error;
        }
        if (configResult.data === null) {
            throw new Error("This workspace does not have an enabled UI configuration.");
        }
        setWorkspaceConfigFromUiConfig(firstWorkspace.id, configResult.data.configuration);
        throw redirect(configPageNavigation(firstWorkspace.id, PageType.AccountSettings));
    },
});
